import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// A vertical (Shorts) YouTube video that shows only a thumbnail until it is
// clicked, so pages with several videos stay fast. The player comes from
// YouTube's privacy-enhanced domain.
const YouTubeShort = ({ id, title, maxWidth = 300 }) => {
  const [playing, setPlaying] = useState(false);
  const [thumb, setThumb] = useState(
    `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`
  );

  return (
    <div style={{ ...styles.frame, maxWidth }}>
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={styles.fill}
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          aria-label={`Play video: ${title}`}
          className="video-play"
          style={styles.button}
        >
          <img
            src={thumb}
            alt=""
            loading="lazy"
            onError={() => setThumb(`https://i.ytimg.com/vi/${id}/hqdefault.jpg`)}
            style={styles.thumb}
          />
          <span style={styles.playBadge}>
            <FontAwesomeIcon icon="fa-solid fa-play" />
          </span>
        </button>
      )}
    </div>
  );
};

export default YouTubeShort;

const styles = {
  button: {
    background: "none",
    border: "none",
    cursor: "pointer",
    height: "100%",
    left: 0,
    padding: 0,
    position: "absolute",
    top: 0,
    width: "100%",
  },
  fill: {
    border: 0,
    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%",
  },
  frame: {
    aspectRatio: "9 / 16",
    backgroundColor: "#000",
    borderRadius: 16,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.6)",
    margin: "0 auto",
    overflow: "hidden",
    position: "relative",
    width: "100%",
  },
  playBadge: {
    alignItems: "center",
    backgroundColor: "rgba(207, 54, 32, 0.92)",
    borderRadius: "50%",
    color: "#FFF",
    display: "flex",
    fontSize: 22,
    height: 64,
    justifyContent: "center",
    left: "50%",
    paddingLeft: 4,
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: 64,
  },
  thumb: {
    display: "block",
    height: "100%",
    objectFit: "cover",
    width: "100%",
  },
};
